import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAllPricingTable = createAsyncThunk('pricingTable/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/pricing-table/get-all-pricing`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPricingTableByID = createAsyncThunk('pricingTable/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/pricing-table/get-pricing/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addPricingTable = createAsyncThunk('pricingTable/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/pricing-table/create-pricing`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editPricingTable = createAsyncThunk('pricingTable/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/pricing-table/update-pricing/${data?.id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deletePricingTable = createAsyncThunk('pricingTable/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/pricing-table/delete-pricing/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllService = createAsyncThunk('pricingTable/all/service', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/service/get-all-services`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addNewService = createAsyncThunk('pricingTable/add/service', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/service/create-service`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})


export const getDefaultPricing = createAsyncThunk('pricingTable/get/default-pricing', async (_,{ rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/pricing-table/default-pricing`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allPricingTable: [],
  allService: [],
  pricingData: null,
  error: null,
  defaultPricing:null
}

const pricingTableSlice = createSlice({
  name: 'pricingTable',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllPricingTable.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllPricingTable.fulfilled, (state, action) => {
        state.isLoading = false
        state.allPricingTable = action.payload?.data?.data
      })
      .addCase(getAllPricingTable.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getPricingTableByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPricingTableByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.pricingData = action.payload?.data?.data
      })
      .addCase(getPricingTableByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addPricingTable.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addPricingTable.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addPricingTable.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editPricingTable.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editPricingTable.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editPricingTable.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deletePricingTable.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deletePricingTable.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deletePricingTable.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllService.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllService.fulfilled, (state, action) => {
        state.isLoading = false
        state.allService = action.payload?.data?.data
      })
      .addCase(getAllService.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addNewService.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addNewService.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addNewService.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getDefaultPricing.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getDefaultPricing.fulfilled, (state, action) => {
        state.isLoading = false
        state.defaultPricing = action.payload?.data?.data
      })
      .addCase(getDefaultPricing.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default pricingTableSlice.reducer
